<template>
  <el-dialog title="分配" :visible.sync="visible" width="520px">
    <p v-if="isBatch">您共选中当前页{{data.targetIds.length}}条记录</p>
    <el-form :model="data" :rules="rules" ref="assignForm" label-width="90px">
      <el-form-item label="新负责人:" prop="managerId">
        <UserSelect v-model="data.managerId" placeholder="请选择负责人"></UserSelect>
        <el-checkbox v-if="showGroupCheckbox" v-model="data.assignCustomerOtherFlag">分配客户下联系人、线索、商机给新负责人</el-checkbox>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { batchChangeManager } from "@/api/crm/assign";
import UserSelect from "@/views/crm/components/userSelect";

export default {
  name: "AssignDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      isBatch: false,
      rules: {
        managerId: [
          {required: true, type: 'number', message: '请选择负责人', trigger: 'change'}
        ]
      },
      showGroupCheckbox: false,
      data: {
        targetIds: [],
        targetType: null,
        managerId: null,
        assignCustomerOtherFlag: false
      }
    };
  },
  created() {
  },
  components: {
    UserSelect
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("assignForm");
      }
    }
  },
  methods: {
    batchAssign (targetType, ids) {
      if (!ids || ids.length <= 0) {
        this.msgError("没有选中任何记录")
        return
      }
      this.data.assignCustomerOtherFlag = false
      if (targetType === 'customer') {
        this.showGroupCheckbox = true
      } else {
        this.showGroupCheckbox = false
      }
      this.isBatch = true
      this.data.targetType = targetType
      this.data.targetIds = ids
      this.visible = true
    },
    singleAssign (targetType, id) {
      if (!id) {
        this.msgError("没有选中任何记录")
        return
      }
      this.data.assignCustomerOtherFlag = false
      if (targetType === 'customer') {
        this.showGroupCheckbox = true
      } else {
        this.showGroupCheckbox = false
      }
      this.isBatch = false
      this.data.targetType = targetType
      this.data.targetIds = [id]
      this.visible = true
    },
    confirm () {
      this.$refs['assignForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          batchChangeManager(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("负责人重新分配成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
